import { CreateTPMode } from '@components/trackingPlans/createTrackingPlans/types';
import { LIBRARIES_TABS } from '@components/transformationsV2/libraries/constants';
import { TRANSFORMATIONS_TABS } from '@components/transformationsV2/transformations/constants';

export const Path = {
  CREATE_DESTINATION: '/addDestination',
  CONNECT_EXISTING_SOURCE: (id: string) => `/destinations/${id}/connect`,
  CONNECT_EXISTING_DESTINATION: (id: string) => `/sources/${id}/connect`,
  CONNECT_NEW_DESTINATION: (id: string) => `/sources/${id}/connectNewDestination`,
  CREATE_SOURCE: '/addSource',
  CONNECT_NEW_SOURCE: (destinationId: string) => `/destinations/${destinationId}/connectNewSource`,
  CLONE_DESTINATION: (destinationId: string) => `/destinations/${destinationId}/clone`,
  HOME: '/',
  ACCOUNT_SETUP: '/setup',
  GET_STARTED: '/getStarted',
  PROFILE: '/profile',
  WORKSPACE: '/workspace',
  ORGANIZATION: '/organization',
  SOURCES: '/sources',
  SOURCE_DETAILS: (id = ':id') => `${Path.SOURCES}/${id}`,
  DESTINATIONS: '/destinations',
  DESTINATION_DETAILS: (id = ':id') => `${Path.DESTINATIONS}/${id}`,
  DESTINATION_MAPPING_CONFIG: (id = ':id') => `${Path.DESTINATIONS}/${id}/mapping`,
  SYNCS: '/syncs',
  MODELS: '/models',
  MODEL_DETAILS: (id = ':id') => `${Path.MODELS}/${id}`,
  MODELS_SETUP: '/modelsSetup',
  AUDIENCES: '/audiences',
  DATA_GRAPH_AUDIENCES: '/dataGraphAudiences',
  DATA_GRAPH_AUDIENCE_DETAILS: (id = ':id') => `${Path.DATA_GRAPH_AUDIENCES}/${id}`,
  DATA_GRAPH_AUDIENCE_SYNC_DETAILS: (audienceId = ':audienceId', syncId = ':syncId') =>
    `${Path.DATA_GRAPH_AUDIENCES}/${audienceId}/syncs/${syncId}`,
  AUDIENCE_SETUP: '/audiencesSetup',
  AUDIENCE_DETAILS: (id = ':id') => `${Path.AUDIENCES}/${id}`,
  AUDIENCE_CONNECT: (id = ':id') => `/audiences/${id}/connect`,
  PROFILES: '/profiles',
  PROFILES_SETUP: '/profiles/setup',
  PROFILES_CONVERT: (id: string) => `/profiles/${id}/convert`,
  PROFILES_EDIT: (id: string) => `/profiles/${id}/edit`,
  PROFILES_COPILOT_EDIT: (id: string) => `/profiles/${id}/copilot-edit`,
  PROFILES_COPILOT_SUCCESS: (id: string) => `/profiles/${id}/copilot-success`,
  PROFILES_COPILOT_EDITOR: (id: string) => `/profiles/${id}/editor`,
  PROFILES_OPEN_ENTITY: ({ profileId, entity }: { profileId: string; entity: string }) =>
    `/profiles/${profileId}/entities/${entity}`,
  PROFILES_OPEN: (id: string) => `/profiles/${id}`,
  PROFILES_OPEN_ENTITY_COHORT: (id: string, entityId: string, cohortId: string) =>
    `/profiles/${id}/entities/${entityId}/cohorts/${cohortId}`,
  PROFILES_ACTIVATION: (id: string, entityId: string, cohortId: string) =>
    `/profiles/${id}/entities/${entityId}/cohorts/${cohortId}/activate`,
  COHORT_AUDIENCES: '/audiences-v2',
  COHORT_AUDIENCE_SETUP: () => `${Path.COHORT_AUDIENCES}/setup`,
  COHORT_AUDIENCE_DETAILS: (id: string) => `${Path.COHORT_AUDIENCES}/${id}`,
  PROFILES_ACTIVATION_SOURCE: (id: string, entityId: string, cohortId: string, sourceId: string) =>
    `/profiles/${id}/entities/${entityId}/cohorts/${cohortId}/sources/${sourceId}`,
  DIRECTORY: '/directory',
  TRANSFORMATIONS: '/transformations',
  TRANSFORMATION_DETAILS: (id: string, tab?: TRANSFORMATIONS_TABS) =>
    `${Path.TRANSFORMATIONS}/${id}${tab ? `?tab=${tab}` : ''}`,
  LIBRARIES: '/libraries',
  LIBRARY_DETAILS: (id: string, tab?: LIBRARIES_TABS) =>
    `/libraries/${id}${tab ? `?tab=${tab}` : ''}`,
  ADD_TRANSFORMATION: '/transformations/add',
  TRACKING_PLANS: '/trackingPlans',
  SETUP_TRACKING_PLAN: '/trackingPlans/setup',
  TRACKING_PLAN_DETAILS: (id: string) => `${Path.TRACKING_PLANS}/${id}`,
  LINK_NEW_SOURCE: (id: string) => `${Path.TRACKING_PLANS}/${id}/linkSource`,
  LINK_TRACKING_PLAN: (id: string) => `/sources/${id}/linkTrackingPlan`,
  TRACKING_PLANS_SETUP: (mode: CreateTPMode | ':mode') => `${Path.TRACKING_PLANS}/setup/${mode}`,
  LOGIN: '/login',
  AUTHORIZE: '/authorize',
  SIGNUP: '/signup',
  CANNY: '/canny',
  FORGOT_PASSWORD: '/forgotPassword',
  SSO: '/sso',
  HEALTH_DASHBOARD: '/healthDashboard',
  INVOICES: '/invoices',
  SELECT_ORGANIZATION: '/selectOrganization',
  USER_SUSPENDED: '/userSuspended',
  DATA_CATALOG: '/dataCatalog',
  ADD_SOURCE_V1: '/addSourceV1',
  CONNECTION_DETAILS: (id = ':id') => `/connections/${id}`,
  BOT_MANAGEMENT: '/botManagement',
  EVENT_BLOCKING: '/eventBlocking',
  DATA_MAPPER: '/dataMapper',
  DATA_GRAPH: '/dataGraph',
  TRIAL_EXPIRED: '/trialExpired',
};
